import { render, staticRenderFns } from "./gj-popover-panel.vue?vue&type=template&id=a50ff16a&scoped=true&"
import script from "./gj-popover-panel.vue?vue&type=script&lang=js&"
export * from "./gj-popover-panel.vue?vue&type=script&lang=js&"
import style0 from "./gj-popover-panel.vue?vue&type=style&index=0&id=a50ff16a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50ff16a",
  null
  
)

export default component.exports